import clsx from 'clsx'
import React, {useRef} from 'react'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'

export default function RadioChoice ({context, question, choices}) {

  const [value, setValue] = React.useState('')

  function handleChange(e) {
    setValue(e.target.value)
  }

  return (
    <RadioGroup className={clsx("choices", "radio")} value={value} onChange={handleChange}>
      {choices.map((choice, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 65)
        return (
          <FormControlLabel
            key={index}
            value={`${index}`}
            className="choice"
            checked={choice.correct}
            control={<Radio />}
            label={<div className="choice-caption" dangerouslySetInnerHTML={{__html: choice.html || ''}} />}
          />)
      })}
    </RadioGroup>
  )
}
